module.exports = __webpack_public_path__ + "static/media/honda_contacto_icon.d96c4000.svg";